module.exports = __webpack_public_path__ + "static/img/333.296e6428.png";